export default "__VITE_ASSET__dc48e254__"